export default __webpack_public_path__ + "static/media/logout.59db1aa3.svg";